import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

export type DocumentType =
    | 'supply'
    | 'occurrence'
    | 'occurrenceDispatch'
    | 'patrol'
    | 'shift'
    | 'vehicleChecklist'
    | 'motorcycleChecklist'
    | 'motorizedService'
    | 'doormanChecklist'
    | 'armamentChecklist'
    | 'panicEvent'
    | 'document';

@Injectable({
    providedIn: 'root',
})
export class DocumentNavigationService {
    private readonly router = inject(Router);

    /**
     * Navega para a página de leitura de documento
     */
    navigateToDocument(type: DocumentType, id: string): void {
        this.router.navigate(['/document', type, id]);
    }

    /**
     * Navega para documento de abastecimento
     */
    navigateToSupply(id: string): void {
        this.navigateToDocument('supply', id);
    }

    /**
     * Navega para documento de ocorrência
     */
    navigateToOccurrence(id: string): void {
        this.navigateToDocument('occurrence', id);
    }

    /**
     * Navega para documento de despacho de ocorrência
     */
    navigateToOccurrenceDispatch(id: string): void {
        this.navigateToDocument('occurrenceDispatch', id);
    }

    /**
     * Navega para documento de ronda
     */
    navigateToPatrol(id: string): void {
        this.navigateToDocument('patrol', id);
    }

    /**
     * Navega para documento de turno
     */
    navigateToShift(id: string): void {
        this.navigateToDocument('shift', id);
    }

    /**
     * Navega para checklist de veículo
     */
    navigateToVehicleChecklist(id: string): void {
        this.navigateToDocument('vehicleChecklist', id);
    }

    /**
     * Navega para checklist de moto
     */
    navigateToMotorcycleChecklist(id: string): void {
        this.navigateToDocument('motorcycleChecklist', id);
    }

    /**
     * Navega para serviço motorizado
     */
    navigateToMotorizedService(id: string): void {
        this.navigateToDocument('motorizedService', id);
    }

    /**
     * Navega para checklist de porteiro
     */
    navigateToDoormanChecklist(id: string): void {
        this.navigateToDocument('doormanChecklist', id);
    }

    /**
     * Navega para checklist de armamento
     */
    navigateToArmamentChecklist(id: string): void {
        this.navigateToDocument('armamentChecklist', id);
    }

    /**
     * Navega para evento de pânico
     */
    navigateToPanicEvent(id: string): void {
        this.router.navigate(['/eventos-panico', id, 'atendimento']);
    }

    /**
     * Navega para lista de documentos recebidos
     */
    navigateToDocuments(): void {
        this.router.navigate(['/documentos-recebidos']);
    }
}
